import {Button, Text} from '@smart/react-components';
import React from 'react';
import styles from './error-message.module.scss';

const baseClass = `error`;

const errorLocale = {
  heading: `Technical error`,
  subHeading: `We apologize.`,
  message: `Something went wrong....`,
  backButtonLabel: `Back`,
  refreshButtonLabel: `Refresh`,
  supportButtonLabel: `Contact Support`,
  supportPagePath: ``,
};

export function ErrorInRoot(): JSX.Element {
  const navigateBack = () => {
    window.history.back();
  };

  return (
    <div className={styles[baseClass]}>
      <Text variant="hl-300" className={styles[`${baseClass}__main-heading`]}>
        {errorLocale.heading}
      </Text>
      <Text variant="hl-100" className={styles[`${baseClass}__sub-heading`]}>
        {errorLocale.subHeading}
      </Text>
      <Text variant="p-200" className={styles[`${baseClass}__content`]}>
        {errorLocale.message}
      </Text>
      <Button
        type="button"
        variant="primary"
        className={styles[`${baseClass}__back-btn`]}
        onClick={navigateBack}
      >
        {errorLocale.backButtonLabel}
      </Button>
    </div>
  );
}
